/**
 * Used to Manage Summary for WG
 */
import API from "../apiEndPoint";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getDashboardDataAPI = createAsyncThunk(
  "getDashboardDataAPI",
  async (__, { getState }) => {
    try {
      const config = {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: getState()?.auth?.token,
        },
      };

      let response = await API.get(`/seller/dashboard`, config);
      console.log("getDashboardDataAPI", response?.data);
      return response?.data;
    } catch (error) {
      console.log(error);
      return error?.response?.data;
    }
  },
);
